import CONST from '@tutils/Constants';

export default {
  methods: {
    isSiteEu() {
      return ACC.config.society === "00001";
    },
    isSiteUs() {
      return ACC.config.society === "US3";
    },
    isSiteCn() {
      return ACC.config.society === "00401";
    },
    isSiteJp() {
      return ACC.config.society === "00101";
    },
    isSiteKr() {
      return ACC.config.society === "00601";
    },
    isFlagCustom(flag) {
      return flag === CONST.DIVISION.FLAGS.FLAGLOROPIANAFABRICS || flag === CONST.DIVISION.FLAGS.FLAGSOLBIATIFABRICS
    },
    isFlagYarns(flag) {
      return flag === CONST.DIVISION.FLAGS.FLAGYARNS
    },
    isAnyFlagShowroom(){
      return CONST.DIVISION.FLAGS.SHOWROOM.includes(ACC.config.flagVistaDivision)
    },
    isDivisionYarns() {
      return ACC.config.sessionDivision.code === CONST.DIVISION.CODE.YARNS
    },

  }
}



// WEBPACK FOOTER //
// ./src/global/mixins/SiteMixins.js